import { render, staticRenderFns } from "./bcfooter.vue?vue&type=template&id=41af7f74&scoped=true&"
import script from "./bcfooter.vue?vue&type=script&lang=js&"
export * from "./bcfooter.vue?vue&type=script&lang=js&"
import style0 from "./bcfooter.vue?vue&type=style&index=0&id=41af7f74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41af7f74",
  null
  
)

export default component.exports